import type { ShipmentStatus } from '../enums/ShipmentStatus'

export class ShipmentStatusLogEntity {
  status?: ShipmentStatus
  date?: string
}
